<template>
  <el-form ref="form" :inline="true" :model="form" size="small">
    <el-form-item label="Ano" label-width="30px">
      <el-select v-model="form.ano" placeholder="Ano" size="mini" :default-first-option="true">
        <el-option v-for="item in anos" :label="item" :value="item" :key="item"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="Mes">
      <el-select v-model="form.mes" placeholder="Mês" size="mini">
        <el-option v-for="item in meses" :label="item.nome" :value="item.mes" :key="item.mes"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click.prevent="aplicar()">Aplicar</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
  import {mapGetters, mapState} from 'vuex'

  export default {
    name: "IndexFilter",
    computed: {
      ...mapState(['anos', 'anoSelected', 'meses', 'mesSelected']),
    },
    data() {
      return {
        form: {
          mes: null,
          ano: null,
        }
      }
    },
    methods: {
      aplicar() {
        this.$emit('filtroAplicado', {
          ano: this.form.ano,
          mes: this.form.mes
        })
      }
    },
    mounted() {
      this.form.ano = this.anoSelected
      this.form.mes = this.mesSelected
    }
  }
</script>



// WEBPACK FOOTER //
// src/features/Competencia/IndexFilter.vue